import { Flex } from '@chakra-ui/react';
import { FormFeedback, OutlineCard } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { RadioGroup } from 'src/components/RadioGroup';
import { FormFieldTransparentPeerReview } from '@publishing-engine/domain/types/article';
import { get } from 'lodash';

const TransparentPeerReview = ({
  config
}: {
  config: FormFieldTransparentPeerReview;
}) => {
  const {
    formState: { errors },
    control
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;
  const error = get(errors, field);

  return (
    <OutlineCard width="100%" padding={4}>
      <Flex flexDirection="column" gap={4} width="100%">
        <FieldLabel
          label={labels.main}
          subText={labels.subtitle}
          isRequired={validations.required}
          helpText={labels.helpText}
        />

        <RadioGroup
          control={control}
          name={field}
          options={[
            {
              value: true,
              children: labels.options['true']?.main
            },
            {
              value: false,
              children: labels.options['false']?.main
            }
          ]}
        />
        {error ? (
          <FormFeedback variant="error">
            Indicate your preference for transparent peer review before
            proceeding.
          </FormFeedback>
        ) : null}
      </Flex>
    </OutlineCard>
  );
};

export default TransparentPeerReview;
